document.addEventListener('algolia.hooks.initialize', function () {
  window.algoliaShopify.hooks.registerHook('beforeInstantSearchFacetLimitNumber', function (limit) {
    // Modify default limit, then return a number
    return 50;
  });
});

document.addEventListener("algolia.hooks.initialize", function () {
  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteProductTemplate",
    function (_defaultTemplate, templateOptions, distinct, itemLink) {
      // Modify default options, then return them
      const { html, item, components } = templateOptions;


      let algoliaCustomHelpers = new algolia_custom_helpers();
      // Get custom prices from product metafields and append them to results
      algoliaCustomHelpers.getProductMetafieldsAndProcessPrices(item, algoliaShopify.config.products_autocomplete_hits_per_page, true);
      algoliaCustomHelpers.getProductSwatchesCount(item, true);

      return html`
    <a
      href="${itemLink}"
      class="aa-ItemLink aa-ProductItem"
      onClick="${() => algoliaShopify.helpers.handleItemClick(item)}"
    >
      <div class="aa-ItemContent">
        <div class="aa-ItemPicture aa-ItemPicture--loaded">
          <img
            src="${algoliaShopify.helpers.compactImage(item)}"
            alt="${item.title}"
          />
        </div>
        <div class="aa-ItemContentBody">
            <div class="aa-ItemContentBrand">
                ${item.product_type && components.Highlight({ hit: item, attribute: 'product_type' })}
                ${item.vendor && html`<span> by </span>`}
                ${item.vendor && components.Highlight({ hit: item, attribute: 'vendor' })}
            </div>
          <div class="aa-ItemContentTitleWrapper">
            <div class="aa-ItemContentTitle">
              ${components.Highlight({ hit: item, attribute: "title" })}
              <span class="algolia-variant">
                ${algoliaShopify.helpers.variantTitleAddition(item, distinct)}
              </span>
            </div>
          </div>
            <div class="aa-ItemContentPrice custom-price">
                <div class="aa-ItemContentPriceCurrent"></div>
            </div>
          <div class="aa-ItemContentPrice">
            <div class="aa-ItemContentPriceCurrent">
              ${algoliaShopify.helpers.displayPrice(item, distinct)}
            </div>
          </div>
          <p class="ais-hit--swatches-count hidden">[[VALUE]] colors available!</p>
        </div>
      </div>
    </a>
  `;
    }
  );
});

document.addEventListener('algolia.hooks.initialize', function() {
  algoliaShopify.hooks.registerHook('beforeAutocompleteFiltersString', function(_defaultFilter) {
    // Filters for stock policy
    let stockPolicyFilter = '';

    if (algoliaShopify.config.stock_policy === 'deny') {
      // For 'deny' we will filter out all items based on inventory quantity
      stockPolicyFilter = 'inventory_quantity > 0';
    } else if (algoliaShopify.config.stock_policy === 'continue') {
      /**
       * For 'continue' we will filter on `inventory_available` attribute whose
       * value is dependent on:
       * `inventory_quantity > 0 OR inventory_policy == 'continue'`
       */
      stockPolicyFilter = 'inventory_available:true';
    }

    let filters = '';
    if(window.allowed_collections && window.allowed_collections.length > 0) {
      let allowedCollectionsPart = (stockPolicyFilter != '' ? `${stockPolicyFilter}  AND ` : '')
        + '(' + window.allowed_collections.map(c => 'collections:' + c).join(' OR ') ;

      filters = allowedCollectionsPart;

      const excludedCollections = window.excluded_collections.map(c => 'collections:' + c).join(' AND NOT ');
      const wizard_collections = window.wizard_collections ? window.wizard_collections.map(c => 'collections:' + c).join(' OR ') : null;

      // do the main part - use allowed collections and wizard collections
      if(wizard_collections) {
        filters += ` OR ${wizard_collections})`;
      }
      else filters += ')';

      // add the filter collection part - use allowed collections and the filter collection
      if(window.has_filter_collection) {
        filters += ` AND ${ allowedCollectionsPart } OR collections:${window.has_filter_collection})`
      }

      if(excludedCollections.length > 0) {
        filters += ' AND NOT ' + excludedCollections;
      }
    }

    if(typeof window.exclude_tag != "undefined" && window.exclude_tag.length > 0) {
      filters += ' NOT tags:' + window.exclude_tag
    }

    return filters;
  });
});

